/* Candidate only. Requires verified public Site Installation URL and endpoint. */
(function (w, d) {
  'use strict';
  var cfg = w.SfPlausibleConfig, model = w.SfPlausibleModel;
  if (!cfg || !model || cfg.enabled !== true || cfg.siteId !== 'starkfeld.com' || cfg.liveTheme !== true) return;
  if ((w.Shopify && w.Shopify.designMode) || !model.publicUrl(w.location.href)) return;
  function publicEndpoint(value) {
    try { var u = new URL(value); return u.protocol === 'https:' && !u.username && !u.password && !u.search && !u.hash; } catch (_) { return false; }
  }
  if (!publicEndpoint(cfg.scriptUrl) || !publicEndpoint(cfg.endpoint)) return;
  // A pre-existing tracker must be reviewed, not silently duplicated/reconfigured.
  if (w.plausible) return;
  var loaded = false, pageSent = false, seen = new Set();
  function allowed() {
    try { return w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function transform(payload) {
    if (!allowed()) return null;
    var url = model.publicUrl(w.location.href);
    if (!url) return null;
    payload.u = url;
    payload.r = model.referrerOrigin(d.referrer);
    // No arbitrary automatic URL/form/link properties or query strings.
    var p = payload.p || {};
    payload.p = {};
    if (['set-finder', 'recovery-check', 'application-check', 'protein-calculator'].includes(p.tool)) payload.p.tool = p.tool;
    if (['guide', 'newsletter'].includes(p.form_type)) payload.p.form_type = p.form_type;
    return payload;
  }
  function boot() {
    // content_for_header can expose Shopify asynchronously after the early context snippet.
    if (typeof w.SfPlausibleSyncContext === 'function') w.SfPlausibleSyncContext();
    if (!allowed() || loaded) return;
    loaded = true;
    w.plausible = function () { (w.plausible.q = w.plausible.q || []).push(arguments); };
    w.plausible.init = function (options) { w.plausible.o = options; };
    w.plausible.init({ endpoint: cfg.endpoint, autoCapturePageviews: false, outboundLinks: false, fileDownloads: false,
      formSubmissions: false, hashBasedRouting: false, captureOnLocalhost: false, transformRequest: transform });
    pageSent = true;
    w.plausible('pageview', { url: model.publicUrl(w.location.href) });
    var script = d.createElement('script'); script.async = true; script.src = cfg.scriptUrl;
    d.head.appendChild(script);
  }
  function sendOnce(name, props, key) {
    if (!allowed()) return;
    boot();
    if (!loaded || seen.has(key)) return;
    seen.add(key); w.plausible(name, { props: props || {}, url: model.publicUrl(w.location.href) });
  }
  ['sf:rx', 'sf:rc', 'sf:bk', 'sf:protein-result'].forEach(function (channel) {
    var target = channel === 'sf:rx' || channel === 'sf:protein-result' ? d : w;
    target.addEventListener(channel, function (event) {
      var mapped = model.tool(channel, event.detail);
      if (mapped) sendOnce(mapped.name, mapped.props, channel + ':' + mapped.name);
    });
  });
  d.addEventListener('sf:newsletter-request-accepted', function () {
    sendOnce('Lead Request Accepted', { form_type: 'newsletter' }, 'lead-accepted');
  });
  // A neutral event emitted only after an actual guide request has been accepted.
  d.addEventListener('sf:guide-request-accepted', function () {
    sendOnce('Lead Request Accepted', { form_type: 'guide' }, 'guide-accepted');
  });
  // Explicit publisher integration only; do not count every anchor or submit click.
  d.addEventListener('sf:guide-download', function () { sendOnce('Guide Download', {}, 'guide-download'); });
  d.addEventListener('visitorConsentCollected', boot);
  d.addEventListener('sf:consent-changed', boot);
  if (w.Shopify && w.Shopify.loadFeatures) w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) boot(); });
  boot();
})(window, document);
